import React from 'react'
import Navbar from '../Components/Navbar'
import Sale from '../Components/Sale'
import TrackSales from '../Components/TrackSales'
import Footer from '../Components/Footer'
import Search from '../Components/Search'

const Forsale = () => {
  return (
    <>
    <Navbar/>
    <Sale/>
    <TrackSales/>
    <Footer/>
    <Search/>
    </>
  )
}

export default Forsale